import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import PowerFacilities from '../components/power/power_facilities/PowerFacilities';
import PowerForecasts from '../components/power/power_forecasts/PowerForecasts';
import InstalledCapacity from '../components/power/installed_capacity/InstalledCapacity';
import PowerData from '../components/power/power_data/PowerData';

const Power: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>('forecasts');
  const navigate = useNavigate();
  const location = useLocation();

  // Extract tab from URL path if available
  useEffect(() => {
    const path = location.pathname.split('/');
    if (path.length > 2) {
      const tab = path[2];
      if (['facilities', 'forecasts', 'data', 'capacity'].includes(tab)) {
        setActiveTab(tab);
      }
    } else if (path.length === 2 && path[1] === 'power') {
      // Redirect from /power to /power/forecasts
      navigate('/power/forecasts', { replace: true });
    }
  }, [location.pathname, navigate]);

  return (
    <div className="container mx-auto p-6">
      <h1 className="text-xl font-bold mb-6 text-gray-900 dark:text-gray-100">Power Data</h1>

      {/* Tabs */}
      <div className="border-b border-gray-200 dark:border-gray-700 mb-6">
        <ul className="flex flex-wrap -mb-px">
          <li className="mr-2">
            <Link
              to="/power/forecasts"
              className={`inline-block p-4 ${
                activeTab === 'forecasts'
                  ? 'text-[rgb(227,66,144)] border-b-2 border-[rgb(227,66,144)] rounded-t-lg active'
                  : 'text-gray-500 hover:text-gray-600 hover:border-gray-300 border-b-2 border-transparent rounded-t-lg'
              }`}
            >
              Power Forecasts
            </Link>
          </li>
          <li className="mr-2">
            <Link
              to="/power/facilities"
              className={`inline-block p-4 ${
                activeTab === 'facilities'
                  ? 'text-[rgb(227,66,144)] border-b-2 border-[rgb(227,66,144)] rounded-t-lg active'
                  : 'text-gray-500 hover:text-gray-600 hover:border-gray-300 border-b-2 border-transparent rounded-t-lg'
              }`}
            >
              Power Facilities
            </Link>
          </li>
          <li className="mr-2">
            <Link
              to="/power/data"
              className={`inline-block p-4 ${
                activeTab === 'data'
                  ? 'text-[rgb(227,66,144)] border-b-2 border-[rgb(227,66,144)] rounded-t-lg active'
                  : 'text-gray-500 hover:text-gray-600 hover:border-gray-300 border-b-2 border-transparent rounded-t-lg'
              }`}
            >
              Power Data
            </Link>
          </li>
          <li>
            <Link
              to="/power/capacity"
              className={`inline-block p-4 ${
                activeTab === 'capacity'
                  ? 'text-[rgb(227,66,144)] border-b-2 border-[rgb(227,66,144)] rounded-t-lg active'
                  : 'text-gray-500 hover:text-gray-600 hover:border-gray-300 border-b-2 border-transparent rounded-t-lg'
              }`}
            >
              Installed Capacity
            </Link>
          </li>
        </ul>
      </div>

      {/* Tab content */}
      <div>
        {activeTab === 'facilities' && <PowerFacilities defaultCountryCode="DE" />}

        {activeTab === 'forecasts' && <PowerForecasts defaultCountryCode="DE" />}

        {activeTab === 'data' && <PowerData defaultCountryCode="DE" />}

        {activeTab === 'capacity' && <InstalledCapacity defaultCountryCode="DE" />}
      </div>
    </div>
  );
};

export default Power;
